import { autoRegisterFeature } from '@store/features/factory';
import { encounterTypesFeature } from './store/feature';

// Auto-register the feature (keeping original name for API compatibility)
autoRegisterFeature(encounterTypesFeature);

// Export everything
export * from './store';
export * from './components';
export * from './types';
export * from './constants';
export * from './hooks';
